import { UseQueryResult } from "@tanstack/react-query";
import { createContext, useContext } from "react";
import { EstimateContextType } from "../types/EstimateContextType";
import { CFIEstimateDetails } from "../types/CFIEstimateDetails";

enum RefetchScope {
	Files,
	Notes
}

const EstimateContext = createContext<{
	order: EstimateContextType,
	modifyOrder: (details: CFIEstimateDetails) => void
	refetchOrder: (scope?: RefetchScope) => Promise<UseQueryResult>
}>
	({
		order: {} as EstimateContextType,
		modifyOrder: () => { },
		refetchOrder: (scope?: RefetchScope) => { return new Promise(() => { }); }
	});

const useEstimate = () => useContext(EstimateContext);

export { EstimateContext, useEstimate, RefetchScope }
